<template>
    <div>
        <breadcrumb :links="[{ text: 'T-Coins 獎賞計劃' }]" />
        <tcoinContent />
    </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb.vue';
import tcoinContent from '@/components/tcoinContent.vue';

export default {
    components: {
        breadcrumb,
        tcoinContent
    }
};
</script>
